import type { AlbumPage, Photo } from '../data/coffeeTable';
import { albumPhotos, photoTapes, photoTints } from '../data/coffeeTable';

const PHOTOS_PER_PAGE = 2;

/** Groups the album photos into pages. Two-page spreads need an even page count, so a trailing page may be blank. */
export function buildAlbumPages(): AlbumPage[] {
  const pageCount = Math.ceil(albumPhotos.length / PHOTOS_PER_PAGE / 2) * 2;
  return Array.from({ length: pageCount }, (_, p) => ({
    num: p + 1,
    photos: albumPhotos.slice(p * PHOTOS_PER_PAGE, (p + 1) * PHOTOS_PER_PAGE).map((photo, k): Photo => {
      const idx = p * PHOTOS_PER_PAGE + k;
      return {
        ...photo,
        tint: photoTints[(idx + 1) % photoTints.length],
        tape: photoTapes[idx % photoTapes.length],
        rot: k === 0 ? -2.5 : 2,
        align: k === 0 ? 'flex-start' : 'flex-end',
      };
    }),
  }));
}
